import { render, staticRenderFns } from "./fpzInvaccAdd.vue?vue&type=template&id=2c896d24"
import script from "./fpzInvaccAdd.vue?vue&type=script&lang=js"
export * from "./fpzInvaccAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports